import { useState } from "react";
import { useDispatch } from "react-redux";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
import {
  ADMINISTRATOR_ROLE,
  BUDGET_COORDINATOR_ROLE,
  BUDGET_OWNER_ROLE,
  HR_COORDINATOR_ROLE,
} from "common/context/auth/roles";
import { getUser } from "common/utils/user-data";
import { removeLocalStorageItem } from "common/utils/storage/local-storage";
import {
  ADMINISTRATOR_SECTIONS,
  COORDINATOR_SECTIONS,
  HR_COORDINATOR_SECTIONS,
  OWNER_SECTIONS,
} from "common/routes/sections/roles.sections";
import { CURRENT_BUDGET } from "features/budget/budget.constants";
import { changeScenarioName } from "features/budget/wizard/state/wizard.actions";
import { useAuth } from "common/context/auth/auth-context";
import SidebarComponent from "./sidebar.component";

function getUserSectionsByRole(role) {
  if (role === null) {
    return [];
  }

  if (role === ADMINISTRATOR_ROLE) {
    return ADMINISTRATOR_SECTIONS;
  }

  if (role === BUDGET_COORDINATOR_ROLE) {
    return COORDINATOR_SECTIONS;
  }

  if (role === BUDGET_OWNER_ROLE) {
    return OWNER_SECTIONS;
  }

  if (role === HR_COORDINATOR_ROLE) {
    return HR_COORDINATOR_SECTIONS;
  }

  return [];
}

export function SidebarContainer({ className }) {
  const { logout, user } = useAuth();
  const userRole = user === null ? null : user.roles[0]?.value ?? null;

  const dispatch = useDispatch();

  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("xs"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleStartClick = () => {
    removeLocalStorageItem(CURRENT_BUDGET);
    dispatch(changeScenarioName(""));
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const sections = getUserSectionsByRole(userRole);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function handleLogout() {
    logout();
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { name = " ", imageUrl } = getUser() || {};
  const names = name.split(" ");
  const initials = `${name[0]}${names[1] ? names[1][0] : ""}`;

  return (
    <SidebarComponent
      className={className}
      toggleDrawer={toggleDrawer}
      isPhone={isPhone}
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
      sections={sections}
      handleStartClick={handleStartClick}
      imageUrl={imageUrl}
      handleClick={handleClick}
      initials={initials}
      anchorEl={anchorEl}
      handleClose={handleClose}
      handleLogout={handleLogout}
    />
  );
}
